import { Duration } from "./card-duration";
export const Card = {
    Duration,
};

